
import React from 'react';
import TranslatedText from '@/TranslatedText';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const JoinCTA: React.FC = () => {
  return (
    <div className="bg-ahavex-blue py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-white mb-6">
          <TranslatedText text="Ready to Grow Your Business with Ahavex?" />
        </h2>
        <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
          <TranslatedText 
            text="Join hundreds of successful businesses already selling through our platform. Our team is ready to help you get started."
          />
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button size="lg" className="bg-ahavex-gold hover:bg-yellow-500 text-ahavex-blue">
            <TranslatedText text="Apply to Become a Seller" />
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10">
            <TranslatedText text="Contact Sales Team" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default JoinCTA;
